import React from "react";
import { render, screen, fireEvent } from "@testing-library/react";
import "@testing-library/jest-dom";

import { FullPageChatLayout } from "./FullPageChatLayout";

jest.mock("@metalmind-ab/mmagent-chat-ui", () => ({
  ChatMessage: ({ showTimestamps }: { showTimestamps?: boolean }) => (
    <div
      data-testid="message-timestamps"
      data-enabled={String(showTimestamps)}
    />
  ),
  JobProgressIndicator: () => null,
  useChatStore: (selector: (state: any) => any) =>
    selector({
      backgroundJobs: [],
      removeBackgroundJob: jest.fn(),
      messages: [],
    }),
}));

beforeAll(() => {
  Object.defineProperty(HTMLElement.prototype, "scrollIntoView", {
    configurable: true,
    value: jest.fn(),
  });
  Object.defineProperty(URL, "createObjectURL", {
    configurable: true,
    value: jest.fn(() => "blob:test-url"),
  });
  Object.defineProperty(URL, "revokeObjectURL", {
    configurable: true,
    value: jest.fn(),
  });
});

const renderLayout = (
  overrides: Partial<React.ComponentProps<typeof FullPageChatLayout>> = {},
) =>
  render(
    <FullPageChatLayout
      messages={[]}
      onSendMessage={jest.fn()}
      isLoading={false}
      conversations={[]}
      onLoadConversation={jest.fn()}
      onNewConversation={jest.fn()}
      onSearchConversations={jest.fn()}
      onLoadMoreConversations={jest.fn()}
      conversationsLoading={false}
      currentConversationId={null}
      welcomeTitle="Welcome to WS"
      welcomeDescription="Start a new conversation"
      {...overrides}
    />,
  );

it("enables the shared chat timestamp renderer for IDA messages", () => {
  renderLayout({
    messages: [
      { id: "1", role: "assistant", content: "Reply", createdAt: new Date() },
    ] as any,
  });
  expect(screen.getByTestId("message-timestamps")).toHaveAttribute(
    "data-enabled",
    "true",
  );
});
